(function () {
  var FREE_SHIPPING_THRESHOLD =
    window.drawerCartPriceConfig?.shippingFeeThreshold || 0;

  function updateNotice(normalPriceCents) {
    var noticeEl = document.getElementById("free-shipping-notice");
    if (!noticeEl) return;

    var yen = normalPriceCents / 100;

    // 通常商品が0円（レンタルのみ or カート空）→ 送料無料案内を非表示
    if (yen === 0) {
      noticeEl.style.display = "none";
      noticeEl.innerText = "";
      return;
    }

    noticeEl.style.display = "";
    var diff = Math.max(FREE_SHIPPING_THRESHOLD - yen, 0);
    noticeEl.innerText = diff === 0
      ? "送料無料でお届け"
      : "あと ¥" + diff.toLocaleString() + "で送料無料";
  }

  function readAndUpdate() {
    var items = document.querySelector("[data-products] .cart__items");
    if (!items) return;

    var normalCents = parseInt(items.dataset.normalSubtotal || "0", 10);
    updateNotice(normalCents);
  }

  // [data-products] の中身が書き換わったら再計算
  function observe() {
    var target = document.querySelector("[data-products]");
    if (!target) return;

    var observer = new MutationObserver(readAndUpdate);
    observer.observe(target, { childList: true, subtree: true });

    // 既に中身があれば即実行
    readAndUpdate();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observe);
  } else {
    observe();
  }
})();
